import { mapMutations } from 'vuex'
import { processPromisesMixin } from './processPromisesMixin'
import { apiFetchMethodsMixin } from './apiFetchMethodsMixin'

export const teamMembersMixin = {
  mounted() {
    this.orchestrate()
  },
  mixins: [processPromisesMixin, apiFetchMethodsMixin],
  methods: {
    ...mapMutations('peerReview', ['setOverallTotalValue']),
    async orchestrate(func = null) {
      await this.fetchGroupMembers()
      this.splitGroupMembersIntoStudentsAndSupervisors()
      this.setOverallTotalValue(this.students.length * 100)
    },
    splitGroupMembersIntoStudentsAndSupervisors() {
      if (!this.fetchedGroupMembers) {
        return
      }
      this.fetchedGroupMembers.map((userProjectAttribution) => {
        if (userProjectAttribution.user && userProjectAttribution.user.groups) {
          userProjectAttribution.user.groups.map((group) => {
            //eslint-disable-next-line
            if (group.name === 'Students') {
              this.students.push(userProjectAttribution)
            } else if (group.name === 'Supervisors') {
              this.supervisors.push(userProjectAttribution)
            }
            return group
          })
        } else {
          // eslint-disable-next-line no-console
          console.error('User or groups missing in userProjectAttribution:', userProjectAttribution)
        }
        return userProjectAttribution
      })
    }
  }
}
